import Todo from "./Todo";
import { useGetTodosQuery,useTaskLeftQuery } from "../features/api/apiSlice";
import { useState } from "react";

export default function TodoList() {
    const[colors,setColors]=useState([])
    const[status,setStatus]=useState('')
    const { data: todos, isLoading, isError ,isSuccess} = useGetTodosQuery({ colors, status });
    const { data: tasksLeft } = useTaskLeftQuery();

    const handleColorChange = (color) => {
        if (colors.includes(color)) {
            setColors((colors)=>colors.filter(function(item) {
                return item !== color
            }))
        } else {
            setColors((colors)=>[...colors,color])
        }
    };

    const handleStatusChange = (status) => {
        if(status==='Complete'){
            setStatus(true);
        }else if(status==='Incomplete'){
            setStatus(false);
        }else{
            setStatus('');
        }
    };

    return (
        <>
        <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">

            {isLoading && 
                <p>Loading Data . . .</p>
            }
            { isSuccess && todos?.length > 0 ? 
                todos.map((todo) => (
                        <Todo todo={todo} key={todo.id}/>
                    ))
                :
                (!isLoading && !isError) && <p>Filterd data Not found</p>
            }
            {isError && 
                <p>Something went wrong</p>
            }
        </div>

        <hr className="mt-4" />

        <div className="mt-4 flex justify-between text-xs text-gray-500">
            {tasksLeft?.length > 0 &&
            <p>{tasksLeft.length} task(s) left</p>
            }

            <ul className="flex space-x-1 items-center text-xs">
                <li
                    className={`cursor-pointer ${
                        status === "" && "font-bold"
                    }`}
                    onClick={() => handleStatusChange("All")}
                >
                    All
                </li>
                <li>|</li>
                <li
                    className={`cursor-pointer ${
                        status === false && "font-bold"
                    }`}
                    onClick={() => handleStatusChange("Incomplete")}
                >
                    Incomplete
                </li>
                <li>|</li>
                <li
                    className={`cursor-pointer ${
                        status === true && "font-bold"
                    }`}
                    onClick={() => handleStatusChange("Complete")}
                >
                    Complete
                </li>
                <li></li>
                <li></li>
                <li
                    className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
                        colors.includes("green") && "bg-green-500"
                    }`}
                    onClick={() => handleColorChange("green")}
                ></li>
                <li
                    className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
                        colors.includes("red") && "bg-red-500"
                    }`}
                    onClick={() => handleColorChange("red")}
                ></li>
                <li
                    className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
                        colors.includes("yellow") && "bg-yellow-500"
                    }`}
                    onClick={() => handleColorChange("yellow")}
                ></li>
            </ul>
        </div>
        </>
    );
}
